import {
  addNewReward,
  changeLimitDropDownData,
  deleteRewardLimitByIndex,
  resetLimit,
  saveCompleteReward,
  setFormVisibility,
  setRewardFormData,
  setRewardIndex,
} from "./actionType";

const initialValues = {
  rewardType: null,
  overall_limit_id: null,
  count_limit_id: null,
  isOverallLimitSaved: false,
  isOverallLimitActive: true,
  overallLimit: "",
  dailyLimit: "",
  weeklyLimit: "",
  monthlyLimit: "",
  yearlyLimit: "",
  isCountLimitSaved: false,
  isCountLimitActive: true,
  overallCount: "",
  dailyCount: "",
  weeklyCount: "",
  monthlyCount: "",
  yearlyCount: "",
};

const initialState = {
  // rewards: [],
  // showRewardForm: false,
  // activeRewardIndex: null,
  rewards: [initialValues],
  showRewardForm: true,
  activeRewardIndex: 0,
  isEdit: false,
  entity_id: null,
  dropdownData: {
    limitLevel: null,
    category: null,
    subcategory: null,
    product: null,
    merchant: null,
  },
};

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case changeLimitDropDownData:
      return {
        ...state,
        dropdownData: {
          ...state.dropdownData,
          [payload.key]: payload.value,
        },
      };
    case addNewReward:
      return {
        ...state,
        rewards: [...state.rewards, initialValues],
      };
    case setRewardIndex:
      return {
        ...state,
        activeRewardIndex: payload,
      }
    // case setRewardIndex:
    //   const selectedReward = state.rewards[payload];
    //   const remainingRewards = state.rewards.filter((_, index) => index !== payload);
    //   return {
    //     ...state,
    //     activeRewardIndex: remainingRewards.length, // Since it's moving to the end
    //     rewards: [...remainingRewards, selectedReward],
    //   };
    case setFormVisibility:
      return {
        ...state,
        showRewardForm: payload,
      };
    case setRewardFormData:
      return {
        ...state,
        rewards: state.rewards.map((reward, index) =>
          index === state.activeRewardIndex
            ? { ...reward, [payload.field]: payload.value }
            : reward
        ),
      };
    case deleteRewardLimitByIndex:
      return {
        ...state,
        rewards: state.rewards.filter((_, index) => index !== payload),
      };
    case saveCompleteReward:
      return {
        ...state,
        rewards: payload?.rewards ?? [],
        entity_id: payload?.entity_id ?? null,
        showRewardForm: payload?.showRewardForm ?? false,
        activeRewardIndex:payload?.activeRewardIndex ?? null,
        isEdit: payload?.isEdit ?? false,
        dropdownData: payload?.dropdownData ?? {},
      };
    case resetLimit:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
